import { render, staticRenderFns } from "./section-suggestion.vue?vue&type=template&id=19c66eb8&scoped=true"
import script from "./section-suggestion.vue?vue&type=script&lang=js"
export * from "./section-suggestion.vue?vue&type=script&lang=js"
import style0 from "./section-suggestion.vue?vue&type=style&index=0&id=19c66eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c66eb8",
  null
  
)

export default component.exports